import Divider from "../../baseComponents/divider/Divider";
// import Section from "../../baseComponents/section/Section";
import { useTranslation } from "react-i18next";
import Collapse from 'rc-collapse';
const QA = () => {
    const { t } = useTranslation();

    var Panel = Collapse.Panel;
    return (

        <Divider cl="bg-[url('/src/asset/bg10.jfif')]   bg-cover pt-16">
            <div className="w-full  text-white">
                <h1 className="my-16 font-semibold text-3xl   text-start md:text-center   xl:text-6xl   w-full">{t('QuestionsAnswers')}</h1>
                <Collapse accordion={false} className="w-full bg-transparent  border-hidden text-justify text-white" defaultActiveKey={[0, 1, 2, 3]}  >
                    <Panel header={"1. " + t("Q1")} className="text-black " >
                        <div className="">{t("A1")}</div>
                    </Panel>
                    <Panel header={"2. " + t("Q2")} className="text-black" ><div className="">{t("A2")}</div></Panel>
                    <Panel header={"3. " + t("Q3")} className="text-black" ><div className="">{t("A3")}</div></Panel>
                    <Panel header={"4. " + t("Q4")} className="text-black">


                        {t("A41")}<a href="https://support.apple.com/en-mn/guide/iphone/iph3dd32dffe/ios" target="_blank" rel="noreferrer" className="text-blue-400" >{t("L1")} </a>                         {t("A411")}
                        <a href="https://support.apple.com/en-mn/guide/iphone/iph3dd32dffe/ios" target="_blank" rel="noreferrer" className="text-blue-400" >{t("L2")} </a>
                        {t("A42")}

                    </Panel>
                </Collapse>
            </div>


        </Divider>
    );
};
export default QA;